export default __webpack_public_path__ + "static/media/job-gray.7fd79b78.svg";